


import request from '@/utils/request'
class parent {


    //查询所有的账套信息/ztb/queryAllZtb
    getAllzt() {
        return request({
            url: `/ztb/queryAllZtb`,
            method: 'get'
        })
    }
    //删除账套/ztb/deleteZtb/{id}
    delzt(id) {
        return request({
            url: `/ztb/deleteZtb/${id}`,
            method: 'get'
        })
    }
    //跟新账套/ztb/updateAllZtb
    updateZt(data) {
        return request({
            url: '/ztb/updateAllZtb',
            method: 'post',
            data: data
        })
    }

    ///ztb/queryZtb1
    getzt() {
        return request({
            url: `ztb/queryZtb1`,
            method: 'get'
        })
    }

}
let item = new parent()

export default item